// ABOUTME: Turns an assign request failure into the message the assign dialog shows.
// ABOUTME: The server's dealership refusals get a translated message; any other error keeps its own text.

import type { IntlShape } from 'react-intl';

/**
 * DEALERSHIP_LOCKED: the offer keeps the dealership it was assigned to. DEALERSHIP_NOT_ALLOWED: the
 * dealership is not one the user may assign (e.g. their dealership links changed meanwhile).
 */
export function describeAssignError(
    err: unknown,
    formatMessage: IntlShape['formatMessage'],
): string {
    const message = err instanceof Error ? err.message : 'Failed to assign node';
    if (message.startsWith('DEALERSHIP_LOCKED')) {
        return formatMessage({
            id: 'nodeAssignment.dealership-locked',
            defaultMessage: 'This offer already has a dealership, which cannot be changed.',
        });
    }
    if (message.startsWith('DEALERSHIP_NOT_ALLOWED')) {
        return formatMessage({
            id: 'nodeAssignment.dealership-not-allowed',
            defaultMessage: 'You cannot assign this dealership.',
        });
    }
    return message;
}
